"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ENDPOINTS = void 0;
const COOPERATIVE_ENDPOINTS = {
    GET_ALL_PARTNER_CATALOG_PRODUCTS: {
        path: '/v1/cooperatives/{cooperative_id}/products',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/products`,
    },
    GET_ALL_BASIC_COOPERATIVE_VARIANTS: {
        path: '/v1/cooperatives/{cooperative_id}/cooperative-variants',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/cooperative-variants`,
    },
    GET_ONE_PARTNER_CATALOG_PRODUCT: {
        path: '/v1/cooperatives/{cooperative_id}/products/{product_code}',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/products/${params.productId}`,
    },
    GET_COOPERATIVE_ZONE_CHARGES: {
        path: '/backoffice/v1/cooperatives/{cooperative_id}/zone-charges',
        applyParams: (params) => `/backoffice/v1/cooperatives/${params.cooperativeId}/zone-charges`,
    },
    GET_ALL_PARTNER_PRODUCTS: {
        path: '/backoffice/v1/partners/{partner_id}/partner-products',
        applyParams: (params) => `/backoffice/v1/partners/${params.partnerId}/partner-products`,
    },
    GET_ALL_COOPERATIVE_VARIANTS: {
        path: '/v1/cooperatives/{cooperative_id}/variants',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/variants`,
    },
    GET_ALL_COOPERATIVE_PRODUCTS_SUMMARY: {
        path: '/v1/cooperative-products/summary',
    },
    GET_ALL_COOPERATIVE_IMPORT_REPORTS: {
        path: '/v1/cooperatives/{cooperative_id}/{report_type}/import-reports',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/${params.reportType}/import-reports`,
    },
    GET_ONE_COOPERATIVE_IMPORT_REPORT: {
        path: '/v1/cooperatives/{cooperative_id}/{report_type}/import-reports/{import_report_id}',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/${params.reportType}/import-reports/${params.importReportId}`,
    },
    GET_COOPERATIVE_LATEST_IMPORT_REPORT: {
        path: '/v1/cooperatives/{cooperative_id}/{report_type_latest}/import-reports/latest',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/${params.reportTypeLatest}/import-reports/latest`,
    },
    UPDATE_COOPERATIVE_PRODUCT: {
        path: '/v1/cooperatives/{cooperative_id}/products/{product_id}',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/products/${params.productId}`,
    },
    UPDATE_COOPERATIVE_VARIANT: {
        path: '/v1/cooperative-variants/{cooperative_variant_id}',
        applyParams: (params) => `/v1/cooperative-variants/${params.cooperativeVariantId}`,
    },
    UPDATE_COOPERATIVE_SUGESTED_PRODUCTS: {
        path: '/v1/cooperatives/{cooperative_id}/products/{product_id}/associated-product',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/products/${params.productId}/associated-product`,
    },
    DELETE_COOPERATIVE_SUGESTED_PRODUCTS: {
        path: '/v1/cooperatives/{cooperative_id}/products/{product_id}/associated-product',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/products/${params.productId}/associated-product`,
    },
    PUT_COOPERATIVE_CATALOG: {
        path: '/v1/cooperatives/{cooperative_id}/variants',
        applyParams: (params) => `/v1/cooperatives/${params.cooperativeId}/variants`,
    },
    PUT_COOPERATIVE_CATALOG_V2: {
        path: '/v2/cooperatives/{cooperative_id}/variants/{sub_task_id}',
        applyParams: (params) => `/v2/cooperatives/${params.cooperativeId}/variants/${params.subTaskId}`,
    },
    PUT_PARTNER_PRODUCT: {
        path: '/backoffice/v1/partners/{partner_id}/partner-products',
        applyParams: (params) => `/backoffice/v1/partners/${params.partnerId}/partner-products`,
    },
    PUT_PARTNER_PRODUCT_V2: {
        path: '/backoffice/v2/partners/{partner_id}/partner-products/{sub_task_id}',
        applyParams: (params) => `/backoffice/v2/partners/${params.partnerId}/partner-products/${params.subTaskId}`,
    },
};
const PRODUCTS_ENDPOINTS = {
    GET_ONE_PRODUCT: {
        path: '/v1/products/{product_code}',
        applyParams: (product_code) => `/v1/products/${product_code}`,
    },
    GET_PRODUCTS_BY_SKUS: {
        path: '/v1/product-by-skus',
    },
    GET_PRODUCTS: {
        path: '/v1/products',
    },
    GET_PRODUCTS_SUMMARY: {
        path: '/v1/products/summary',
    },
    GET_PRODUCTS_SUMMARY_FULL: {
        path: '/v1/products-summary/full',
    },
};
const DATASET_ENDPOINTS = {
    CREATE_DATASET_PRODUIT: {
        path: '/v1/dataset/products',
    },
    GET_ONE_DATASET_PRODUIT: {
        path: '/v1/dataset/products/{product_id}',
        applyParams: (productId) => `/v1/dataset/products/${productId}`,
    },
    GET_DATASET_PRODUITS: {
        path: '/v1/dataset/products',
    },
    DELETE_DATASET_PRODUIT: {
        path: '/v1/dataset/products/{product_id}',
        applyParams: (productId) => `/v1/dataset/products/${productId}`,
    },
    ADD_VARIANT_DATASET_TO_PARTNER_CATALOG: {
        path: '/v1/dataset/cooperatives/{partner_id}/variants',
        applyParams: (partnerId) => `/v1/dataset/cooperatives/${partnerId}/variants`,
    },
    REMOVE_VARIANT_DATASET_FROM_PARTNER_CATALOG: {
        path: '/v1/dataset/cooperatives/{partner_id}/variants/{variant_id}',
        applyParams: (partnerId, variantId) => `/v1/dataset/cooperatives/${partnerId}/variants/${variantId}`,
    },
    SUBMIT_DATASET_PRODUCT_INDEXING_TASK: {
        path: '/v1/dataset/products/indexing',
        applyParams: () => `/v1/dataset/products/indexing`,
    },
    SUBMIT_DATASET_PARTNER_INDEXING_TASK: {
        path: '/v1/dataset/cooperatives/{partner_id}/indexing',
        applyParams: (partnerId) => `/v1/dataset/cooperatives/${partnerId}/indexing`,
    },
    GET_DATASET_PARTNER_INDEXING_TASK: {
        path: '/v1/dataset/cooperatives/{partner_id}/indexing',
        applyParams: (partnerId) => `/v1/dataset/cooperatives/${partnerId}/indexing`,
    },
};
const CUSTOM_CONFIG_ENDPOINTS = {
    GET_CUSTOM_CONFIG: {
        path: '/v1/products/custom-configurations/{custom_config_id}',
        applyParams: (customConfigId) => `/v1/products/custom-configurations/${customConfigId}`,
    },
    GET_PARTNER_CUSTOM_CONFIG: {
        path: '/v1/products/partners/{partner_id}/custom-configurations/{custom_config_id}',
        applyParams: (partnerId, customConfigId) => `/v1/products/partners/${partnerId}/custom-configurations/${customConfigId}`,
    },
    UPDATE_PARTNER_CUSTOM_CONFIG: {
        path: '/v1/products/partners/{partner_id}/custom-configurations/{custom_config_id}',
        applyParams: (partnerId, customConfigId) => `/v1/products/partners/${partnerId}/custom-configurations/${customConfigId}`,
    },
    DELETE_PARTNER_CUSTOM_FILTER: {
        path: '/v1/products/partners/{partner_id}/custom-configurations/filters',
        applyParams: (partnerId) => `/v1/products/partners/${partnerId}/custom-configurations/filters`,
    },
};
exports.ENDPOINTS = {
    ...PRODUCTS_ENDPOINTS,
    ...COOPERATIVE_ENDPOINTS,
    ...DATASET_ENDPOINTS,
    ...CUSTOM_CONFIG_ENDPOINTS,
    GET_ALL_SUPPLIERS: {
        path: '/national-referential/v1/suppliers',
        applyParams: () => `/national-referential/v1/suppliers`,
    },
    GET_ALL_CATEGORIES: {
        path: '/national-referential/v2/categories',
        applyParams: () => `/national-referential/v2/categories`,
    },
    GET_CROPS: {
        path: '/v1/crops',
        applyParams: () => `/v1/crops`,
    },
    GET_USAGES: {
        path: '/v1/usages',
        applyParams: () => `/v1/usages`,
    },
    GET_REDIRECTION: {
        path: '/v1/redirections',
    },
    GET_ATTRIBUTES: {
        path: '/v1/attributes',
        applyParams: () => `/v1/attributes`,
    },
};
